<template>
  <div class="page-wrapper" style="padding-top: 0">
    <h3>基础信息</h3>

    <!--<div class="flex">-->
    <div class="item">
      <div class="flex">
        <div class="left">项目名称：</div>
        <div class="bold">{{pageData.projectName}}</div>
      </div>
    </div>
    <div class="item">
      <div class="flex">
      <div class="left">项目地址：</div>
      <div class="bold">{{pageData.projectAddress}}</div>
      </div>
    </div>

    <div class="item">
      <span class="left">所属城市：</span>
      <span class="bold">{{pageData.projectCityNameVO}}</span>
    </div>
    <div class="item">
      <span class="left">所属区域：</span>
      <span class="bold">{{pageData.projectRegionNameVO}}</span>
    </div>

    <!--</div>-->

    <!--<div class="flex">-->
    <div class="item">
      <span class="left">空置天数：</span>
      <span class="bold">{{pageData.projectVacancyDay}}</span>
    </div>
    <div class="item">
      <span class="left">租赁天数：</span>
      <span class="bold">{{pageData.projectContractCycle}}</span>
    </div>

    <div class="item">
      <span class="left">经度：</span>
      <span class="bold">{{pageData.projectLon}}</span>
    </div>
    <div class="item">
      <span class="left">纬度：</span>
      <span class="bold">{{pageData.projectLat}}</span>
    </div>

    <!--</div>-->

    <!--<div class="flex">-->

    <div class="item">
      <span>起租日期：</span>
      <span class="bold">{{pageData.projectContractBegin}}</span>
    </div>
    <div class="item">
      <span>到期日期：</span>
      <span class="bold">{{pageData.projectContractEnd}}</span>
    </div>
    <div class="item">
      <span>项目面积：</span>
      <span class="bold">{{pageData.projectArea}}</span>
    </div>
    <div class="item">
      <span>公区面积：</span>
      <span class="bold">{{pageData.projectPublicArea}}</span>
    </div>

    <!--</div>-->


    <div class="item">
      <span>楼栋数：</span>
      <span class="bold">{{pageData.projectBuildingNum}}</span>
    </div>
    <div class="item">
      <span>备案号：</span>
      <span class="bold">{{pageData.caseNum}}</span>
    </div>
    <div class="item">
      <span>资金结算平台：</span>
      <span class="bold">{{pageData.receiptTypeName}}</span>
    </div>

    <br>

    <!--<div class="item">-->
    <!--<span>建成年代</span>-->
    <!--&lt;!&ndash;<span>{{pageData.}}</span>&ndash;&gt;-->
    <!--</div>-->

    <h3>经营信息</h3>

    <!--<div class="flex">-->
    <div class="item">
      <span>项目编码：</span>
      <span>{{pageData.projectCode}}</span>
    </div>

    <div class="item">
      <span>项目状态：</span>
      <span>{{pageData.projectStateVO}}</span>
    </div>

    <div class="item">
      <span>开业日期：</span>
      <span>{{pageData.projectOpeningTime}}</span>
    </div>
    <div class="item">
      <span>合作模式：</span>
      <span>{{pageData.projectCooperationModelVO}}</span>
    </div>

    <!--</div>-->

    <!--<div class="flex">-->
    <div class="item">
      <span>房型数：</span>
      <span class="bold">{{pageData.houseTypeNum}}</span>
    </div>
    <div class="item">
      <span>房间数：</span>
      <span class="bold">{{pageData.houseNum}}</span>
    </div>


    <div class="item">
      <span>车位数：</span>
      <span>{{pageData.projectCarPortNum}}</span>
    </div>

    <div class="item">
      <span>供暖方式：</span>
      <span>{{pageData.heatingModeVO}}</span>
    </div>

    <!--</div>-->

    <!--<div class="flex">-->
    <div class="item">
      <span>用电类别：</span>
      <span>{{pageData.projectPowerTypeName}}</span>
    </div>
    <div class="item">
      <span>电费基价：</span>
      <span>{{pageData.projectPowerPrice}}</span>
    </div>


    <div class="item">
      <span>用水类别：</span>
      <span>{{pageData.projectWaterTypeName}}</span>
    </div>

    <div class="item">
      <span>水费基价：</span>
      <span>{{pageData.projectWaterPrice}}</span>
    </div>
    <!--</div>-->

    <!--<div class="flex">-->
    <div class="item">
      <span>公司编码：</span>
      <span>{{pageData.projectCompanyCode}}</span>
    </div>
    <div class="item">
      <span>收房合同号：</span>
      <span>{{pageData.receivedContract}}</span>
    </div>
    <!--</div>-->

    <div class="item2  flex">
      <span class="lable">结算公司名称：</span>
      <span class="bold">{{pageData.projectCompanyName}}</span>
    </div>


    <div class="item2 flex ">
      <div class="lable">项目简介：</div>
      <div class="bold" v-html="pageData.projectDescription"></div>
    </div>

    <div class="item2 flex">
      <div class="lable">项目说明：</div>
      <div class="bold">{{pageData.projectIntro || '无'}}</div>
    </div>
    <div class="item2 ">
      <div>备注：</div>
      <div class="bold">{{pageData.remark || '无'}}</div>
    </div>
    <div class="item2 ">
      <div>商机电话：</div>
      <div class="bold">{{pageData.numberTypeName || '无'}}</div>
    </div>


    <!--<div class="item">产权类型</div>-->


  </div>
</template>
<script>
  import {getBaseInfoByProjectId} from "../../../../../api/project";

  export default {
    name: "BaseInfo",
    props: {
      projectFid: {
        type: String,
        default: null
      },
      houseTypeNum: {
        type: Number,
        default: 0
      },
      houseNum: {
        type: Number,
        default: 0
      }
    },
    watch: {
      projectFid() {
        this.getBaseInfoByProjectId()
      }
    },

    data() {
      return {
        pageData: {}
      }
    },
    methods: {
      getBaseInfoByProjectId() {
        if (!this.projectFid) {
          return
        }
        var params = {
          projectFid: this.projectFid
        }
        getBaseInfoByProjectId(params).then(res => {
          this.pageData = res.data
          this.$emit('ownerid', res.data.ownerId)
        })
      }

    },
    created() {
      this.getBaseInfoByProjectId()
    }
  }
</script>

<style scoped>
  .item {
    display: inline-block;
    line-height: 1;
    margin-bottom: 25px;
    width: 30%;
    vertical-align: top;
    margin-right: 10px;
    min-width: 150px;

  }

  .item2 {
    margin-bottom: 20px;
    display: flex;

  }

  .left {
    display: inline-block;
  }

  .block {
    display: block;
  }

  h3 {
    margin: 10px 0 25px 0;
    font-size: 12px;
  }

  .m10 {
    margin: 10px 0;
  }
  .lable{
    flex-shrink: 0;
  }

  .item > span:nth-child(2) {
    font-weight: bold;
  }

  .item2 > span:nth-child(2) {
    font-weight: bold;
  }
  .flex{
    display: flex;
  }

</style>
